import { Fragment, useEffect, useState } from 'react';

import { AuthBtn } from '@playbooks/components/auth/auth-btn';
import { CollectionFlow } from '@playbooks/components/collection/collection-flow';
import { useStore, useToast } from '@playbooks/contexts';
import { useAction } from '@playbooks/hooks';

export const BookmarkBtn = ({ layout = '', model, variant, rootApi, ...props }) => {
	const [bookmark, setBookmark] = useState<any>({});
	const [open, setOpen] = useState(false);
	const store = useStore();
	const toast = useToast();

	// Hooks
	useEffect(() => {
		setBookmark(model.social?.bookmark || {});
	}, [model.social]);

	// Actions
	const [onClick, clickTask] = useAction(async () => {
		if (bookmark?.id) return setOpen(true);
		const response = await store.queryRecord({ url: `${rootApi}/bookmark` });
		setBookmark(response.data || {});
		if (response.data?.id) setOpen(true);
	});

	// Methods
	const onFinish = data => {
		setBookmark(data || {});
		setOpen(false);
	};

	// Render
	return (
		<Fragment>
			{layout === 'display' ? (
				<AuthBtn
					prevIcon='bookmark'
					alt='bookmark'
					variant='outline'
					active={bookmark.id}
					taskRunning={clickTask.running}
					onClick={onClick}
					{...props}
					className='bg-surface-hover w-full'>
					{bookmark.id ? 'Bookmarked' : 'Bookmark'}
				</AuthBtn>
			) : (
				<Fragment>
					{variant === 'drop' ? (
						<AuthBtn
							prevIcon='bookmark'
							alt='bookmark'
							variant={variant}
							taskRunning={clickTask.running}
							onClick={onClick}
							{...props}
						/>
					) : (
						<AuthBtn
							size='icon'
							icon='bookmark'
							alt='bookmark'
							variant={variant}
							active={bookmark.id && { color: 'text-action' }}
							taskRunning={clickTask.running}
							onClick={onClick}
							{...props}
						/>
					)}
				</Fragment>
			)}
			<CollectionFlow model={bookmark} open={open} setOpen={setOpen} rootApi={rootApi} onNext={onFinish} />
		</Fragment>
	);
};
